/*
 * Verkoop index
 */
(function($, RAF, load_owl) {

    RAF(function(){

        $('#menu .inner li').first().addClass('pagecur current');
        //Calc height for sub-bg-menu class
        var heightsubnav = $('.current .sub-menu').outerHeight();
        $('.sub-bg-menu').first().css({
            'height': heightsubnav
        });

        $('#tabs-home li:first').addClass('active');
        $('.tab-content div:first').addClass('active').removeClass('fade');
    });

    $('#tabs-home a').on('click', function(e) {
        e.preventDefault();
        $(this).tab('show');
    });

    if ($('#headlines').length) {

        load_owl(function() {

            $('#headlines').addClass('owl-carousel');
        
            $("#headlines").owlCarousel({
                loop: true,
                navigation: true, // Show next and prev buttons
                slideSpeed: 300,
                paginationSpeed: 400,
                singleItem: true,
                navigation: false,
                autoHeight: true,
                autoplay: true,
                singleItem: true, //is a shortcut for:
                items : 1,
                autoplayTimeout: 5000,
                autoplayHoverPause: false
                // itemsDesktop : false,
                // itemsDesktopSmall : false,
                // itemsTablet: false,
                // itemsMobile : false
            });
            $("#headlines .item img").each(function(i, el) {
                $(el).attr('srcset', $(el).data('srcset'));
                //$(el).attr('src', $(el).data('src'));
            });
            $("#headlines").trigger('owl.next');
        });
    }

    if ($('.carousel-brands').length) {

        load_owl(function() {

            $('.carousel-brands').addClass('owl-carousel');

            $('.carousel-brands').owlCarousel({
                autoplay: true,
                loop: true,
                nav: true,
                margin: 30,
                items: 8,
                smartSpeed: 1000,
                rewind: true,
                slideBy: 4,

                autoplayTimeout: 4000,
                autoplayHoverPause: false
            });
        });
    }
})(jQuery, window.RAF, window.load_owl);